var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-center align-center my-4"},[_c('v-progress-circular',{attrs:{"size":_vm.size,"color":"primary","indeterminate":""}}),_c('v-progress-circular',{staticClass:"mx-2",attrs:{"size":_vm.size * 2,"color":"secondary","indeterminate":""}}),_c('v-progress-circular',{attrs:{"size":_vm.size,"color":"primary","indeterminate":""}})],1),_c('p',{class:[
    'text-center',
    ("" + (_vm.$vuetify.breakpoint.smAndDown ? 'subtitle-1' : 'title')),
    'ma-0',
    'font-weight-bold',
    'primary--text'
  ]},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{class:[
    'text-center',
    ("" + (_vm.$vuetify.breakpoint.smAndDown ? 'caption' : 'body-2')),
    'font-weight-light',
    'secondary--text'
  ],attrs:{"pa-1":""}},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }